import React, { useContext } from 'react';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import { UserContext } from '../UserContext';
import { useState, useEffect } from "react";
import Footer from '../Footer';
import './GraphicCourseDetails.css';
import { useNavigate } from 'react-router-dom';
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import FeeStructure from '../components/FeeStructure';
import Testimonials from '../Testimonials';
import tinkercad from './GraphicCourseImages/trinkcard.jpg';
import tinkercadImg from './GraphicCourseImages/tinkercad.png'; // Add appropriate image
import model1 from './GraphicCourseImages/model1.png'; // Add appropriate images
import model2 from './GraphicCourseImages/model2.png';
import model3 from './GraphicCourseImages/model3.png';

const ThreeDModelingCourse = ({ selectedCourse }) => {
  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  
  useEffect(() => {
        const fetchData = async () => {
         await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
            credentials: 'include',
          }).then(response => {
              console.log("Response:",response);
            response.json().then(userInfo => {
              console.log("userinfo:",userInfo);
              setUserInfo(userInfo);
  
              if(userInfo?.usertype)
              {
                const uType=userInfo?.usertype;
                setUserRole(uType);
              }
            const uname = userInfo?.username;
            const avatar = userInfo?.avatar; // Store the avatar in a separate variable
            console.log("Uname: ", uname);
            console.log("Avatar: ", avatar);
  
            })
            .catch(err=> console.log("Error in useeffect:",err))
          });
        }
        fetchData();
      }, [isAdmin, isTeacher, isStudent, isGuest]);
    const determineUserRole = (usertype) => {
          console.log("In home.js:",usertype)
          if(usertype === 'Student')
            return "Student";
          else if(usertype === 'Teacher')
            return "Teacher";
          else if(usertype === 'Admin')
            return "Admin";
          else
            return "guest";
    };
   const navigate=useNavigate();
    const onLogin = (usertype) => {
      const userRole = determineUserRole(usertype);
      console.log("Calling setUserRole.")
      setUserRole(userRole);
    };
  
    function onLogout() {
        console.log("inside Onlogout.");
        fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
          credentials: 'include',
          method: 'POST',
        });
        setUserInfo(null);
        setUserRole('guest');
        navigate("/");
  
      }

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  return (
    <div>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && isGuest && <GuestNav onLogin={onLogin} />}

      {/* Hero Section */}
      <div className="ScratchProg-Background">
        <section className="section">
          <p className="PageHead" style={{ color: "#8b0194" }}>3D Modeling with Tinkercad</p>
          <div className="PageDesc">
            <div style={{ display: "flex" }}>
              <p style={{
                fontFamily: "'DM Sans', sans-serif",
                textAlign: "left",
                padding: "30px",
                fontSize: "22px",
                zIndex: 1,
                color: "#8b0194",
                width: "70%"
              }}>
                Discover the exciting world of 3D design! Our course teaches kids how to create digital models using Tinkercad, 
                from basic shapes to printable designs. Perfect for beginners, this course develops spatial reasoning and 
                creative problem-solving skills through hands-on projects.
              </p>
              <img style={{ minWidth: "250px", maxWidth: "450px" }} src={tinkercadImg} alt="Tinkercad Interface" />
            </div>
            <div className="btn-row d-flex btn-row-resp btn-row-resp1">
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-course" href="#course">Course Structure</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-fee" href="#fee">Fee Structure</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-Testimonal" href="#testimonal">Testimonials</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-Faq" href="#Faq">FAQs</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-registered" href="#">Get Registered</a>
              </div>
            </div>
          </div>
        </section>
        <div className="overlay"></div>
      </div>

      {/* Intro Section */}
      <div className='scratch-background'>
        <section className="section">
          <p className="PageHead" style={{ color: "#8b0194" }}>What is 3D Modeling?</p>
          <div className="PageDesc">
            <p style={{
              color: "#8b0194",
              marginTop: "2vh",
              fontSize: "18px",
              fontFamily: "sans-serif",
            }}>
              3D modeling is the process of creating three-dimensional digital representations of objects. 
              In this course, students use Tinkercad - a free, easy-to-use app for 3D design. Tinkercad is 
              perfect for beginners and allows students to turn their imagination into digital models that 
              can eventually be 3D printed.
              <br /><br />
              Through this course, students will develop spatial reasoning, design thinking, and problem-solving 
              skills. They'll progress from basic shapes to complex designs, learning industry-relevant skills 
              in a fun, project-based environment. The course culminates with students preparing their designs 
              for 3D printing.
            </p>
          </div>
        </section>
      </div>

      {/* Course Structure */}
      <section className="section course-structure" id="course">
        <p className="PageHead" style={{ color: "#8b0194" }}>Course Structure and Syllabus</p>
        
        <h4 className="H4_Heading" style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <b>Course Objectives</b>
        </h4>
        <ul style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <li>Master Tinkercad's interface and basic tools</li>
          <li>Develop spatial reasoning and 3D visualization skills</li>
          <li>Create functional objects and creative designs</li>
          <li>Understand design principles for 3D printing</li>
          <li>Collaborate on complex design projects</li>
        </ul>

        {/* Module 1 */}
        <div>
          <p className='moduleSection'>
            <img src={tinkercad} alt="" style={{ width: "2em", height: "2em" }} />
            Module 1: Introduction to Tinkercad and Basic Shapes
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />1</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>1</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Introduction to Tinkercad
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students will learn the Tinkercad interface, basic shapes, movement tools, and how to combine shapes 
                to create simple objects. The module culminates in a project day to apply all learned skills.
              </p>
            </p>
          </div>
        </div>

       

        {/* Module 2 */}
        <div>
          <p className='moduleSection'>
            <img src={tinkercad} alt="" style={{ width: "2em", height: "2em" }} />
            Module 2: Fun Projects and Simple Designs
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />2</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Practical Design Projects
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students apply their skills to create practical objects like keychains, houses, toy cars, 
                and coins. The module includes a challenge to design a miniature garden.
              </p>
            </p>
          </div>
        </div>

        

        {/* Module 3 */}
        <div>
          <p className='moduleSection'>
            <img src={tinkercad} alt="" style={{ width: "2em", height: "2em" }} />
            Module 3: Advanced Shapes and Techniques
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />3</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Advanced Techniques
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students learn advanced techniques like creating holes, duplicating objects, adding text, 
                and designing moving parts. The module culminates in designing a spaceship.
              </p>
            </p>
          </div>
        </div>

        

        {/* Module 4 */}
        <div>
          <p className='moduleSection'>
            <img src={tinkercad} alt="" style={{ width: "2em", height: "2em" }} />
            Module 4: Real-World Applications and Collaborative Projects
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />4</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>5</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Real-World Applications
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students create functional objects, collaborate on projects, and learn how to prepare 
                designs for 3D printing. The course concludes with a final project showcase.
              </p>
            </p>
          </div>
        </div>

        
        {/* Project Showcase */}
        <h6 style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <b>Student Project Gallery</b>
        </h6>

        <div className="activityImagesContainer" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={model1} alt="Keychain Project" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Custom Keychain</p>
          </div>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={model2} alt="Toy Car Project" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Toy Car Design</p>
          </div>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={model3} alt="Spaceship Project" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Spaceship Model</p>
          </div>
        </div>
      </section>

      {/* Fee Structure */}
      <FeeStructure subject="3D Modeling" />

      <Testimonials />

      {/* FAQs */}
      <div style={{ maxWidth: '100%', backgroundColor: '#edffff' }} id="Faq">
        <MDBContainer className="mt-0" style={{ maxWidth: '180vh' }}>
          <MDBAccordion alwaysOpen initialActive={1}>
            <div className="text-center PageHead" style={{ color: "#8b0194" }}> FAQs</div>
            <MDBAccordionItem collapseId={1} headerTitle="Q: What is Tinkercad and why is it good for kids?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                Tinkercad is a free, browser-based 3D modeling program that uses simple shapes and intuitive tools. 
                It's perfect for kids because it has a gentle learning curve but still teaches real 3D design concepts 
                used by professionals.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={2} headerTitle="Q: Does my child need any special equipment?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                No special equipment is needed! Tinkercad runs in a web browser on any computer. While we teach students 
                how to prepare models for 3D printing, actual printing is optional and not required for the course.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={3} headerTitle="Q: What age group is this course designed for?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                This course is ideal for students aged 9-14. Younger students with good computer skills may also enjoy it, 
                as we provide step-by-step guidance through each project.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={4} headerTitle="Q: Will my child be able to 3D print their designs?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                Yes! We teach students how to prepare their designs for 3D printing. While we don't provide printing services, 
                we'll guide you on how to access local 3D printing options if you want to bring creations to life.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={5} headerTitle="Q: How does this course benefit my child's development?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                3D modeling develops spatial reasoning, creative problem-solving, and technical skills. It also introduces 
                concepts used in engineering, architecture, and game design - valuable exposure to potential career paths.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={6} headerTitle="Q: What if my child misses a lesson?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                All lessons include recorded instructions and project files. Students can review material at their own pace 
                and get help from instructors during office hours.
              </span>
            </MDBAccordionItem>
          </MDBAccordion>
        </MDBContainer>
      </div>

      <Footer />
    </div>
  );
};

export default ThreeDModelingCourse;